import { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

const DefineList = ({
  label,
  list,
  setList,
  suggested,
  removeList,
  mainColor,
  reqiuerd,
}) => {
  const [value, setValue] = useState("");

  const changeHanler = (e) => {
    setValue(e.inputProps.value);
  };
  const submitHandler = () => {
    setList({
      id: Math.floor(Math.random() * 1000),
      title: value,
    });
    setValue("");
  };

  const deleteListHandler = (id) => {
    removeList(id);
  };

  return (
    <>
      <div className="w-full flex flex-wrap min-h-[40px]">
        <label className="mb-2 text-sm w-full">
          {label} {reqiuerd ? <span className="text-red-700">*</span> : ""}
        </label>

        <Autocomplete
          id="free-solo-demo"
          className="h-10 flex-[2] rounded focus:outline-lightGreenKite"
          value={value}
          onChange={(params) => {}}
          freeSolo
          options={suggested.map((option) => option.title)}
          renderInput={(params) => {
            changeHanler(params);
            return <TextField {...params} />;
          }}
        />

        <button
          className={`bg-${
            mainColor ? mainColor : "lightGreenKite"
          } text-white w-11 h-10 rounded-l-md`}
          type="button"
          onClick={submitHandler}
        >
          +
        </button>
        <div className="w-full">
          {list && (
            <ul className="flex flex-wrap gap-2">
              {list.map((item, index) => (
                <li
                  key={index}
                  className={`bg-${
                    mainColor ? mainColor : "lightGreenKite"
                  } text-white text-sm flex items-center justify-end gap-1 mt-2 px-2 py-1 rounded-lg`}
                >
                  <span className="leading-[15px]">{item.title}</span>
                  <span
                    onClick={() => deleteListHandler(item.id)}
                    className="text-white w-4 h-4 flex items-center justify-center cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default DefineList;
